import { type CommunityDetail, useCommunityQuery } from '@pba/react-network';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Button, Dropdown, Flex, Icon, type MenuProps, Modal } from 'ui';
import { useLeaveCommunityMutation } from '../../queries';
import { CommunityJoinedStatusBadge } from './community-joined-status-badge';

type P = {
  community: CommunityDetail;
};

const CommunityJoinedStatus = ({ community }: P) => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { canLeaveCommunityDetail } = usePermissions();
  const { isRefetching: isReloadingCommunity } = useCommunityQuery({ filter: {}, id: community.id });
  const { isPending: isLeavingCommunity, mutate: leaveCommunity } = useLeaveCommunityMutation();

  const dropdownLeave: MenuProps = useMemo(
    () => ({
      items: [
        {
          danger: true,
          icon: <Icon icon="exit-line" />,
          key: 'leave',
          label: t('Leave Community'),
        },
      ],
      onClick() {
        modal.confirm({
          content: (
            <Trans
              components={{ strong: <strong /> }}
              i18nKey="Are you sure you want to leave <strong>{{communityName}}</strong> community?"
              values={{ communityName: community.name }}
            />
          ),
          icon: <Icon color="error" icon="exit-line" />,
          okText: 'Leave',
          onOk() {
            leaveCommunity({ id: community.id });
          },
          title: 'Leave community?',
          type: 'error',
        });
      },
    }),
    [community, leaveCommunity, modal, t],
  );

  const isLoading = isReloadingCommunity || isLeavingCommunity;

  return (
    <>
      {contextHolder}
      {canLeaveCommunityDetail({ community }) ? (
        <Dropdown disabled={isLoading} menu={dropdownLeave} trigger={['click']}>
          <Button loading={isLoading} type="text">
            <Flex align="center" gap="xs">
              <CommunityJoinedStatusBadge />
              <Icon icon="down-line" />
            </Flex>
          </Button>
        </Dropdown>
      ) : (
        <CommunityJoinedStatusBadge />
      )}
    </>
  );
};

export default CommunityJoinedStatus;
